// extracted by mini-css-extract-plugin
export default {"alert__container":"styles_alert__container__f9M3-","alert__text":"styles_alert__text__By7hR"};